import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../../shared/services/api";

const DEFAULT = {
  logo_url: "",
  primary_color: "#0055FF",
  accent_color: "#09090B",
  font_family: "",
};

const BrandContext = createContext({ theme: DEFAULT, logoUrl: "", refresh: () => {} });

function applyCssVars(theme) {
  const root = document.documentElement;
  if (theme.primary_color) {
    root.style.setProperty("--brand-primary", theme.primary_color);
  }
  if (theme.accent_color) {
    root.style.setProperty("--brand-accent", theme.accent_color);
  }
  if (theme.font_family) {
    root.style.setProperty("--brand-font", theme.font_family);
  }
}

export function BrandProvider({ children }) {
  const [theme, setTheme] = useState(DEFAULT);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/content");
      const t = { ...DEFAULT, ...(r.data?.theme || {}) };
      setTheme(t);
      applyCssVars(t);
    } catch (_) { /* ignore */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // v2.71.24 — Memoize so brand consumers don't re-render on parent renders.
  const value = useMemo(
    () => ({ theme, logoUrl: theme.logo_url || "", refresh }),
    [theme, refresh]
  );

  return (
    <BrandContext.Provider value={value}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBrand = () => useContext(BrandContext);
